var _defs, _rect, _rect2, _path, _path2, _rect3, _br, _text, _ellipse, _path3, _path4, _ellipse2, _text2, _path5, _ellipse3, _text3, _ellipse4, _text4, _ellipse5, _ellipse6, _path6, _ellipse7, _path7, _path8, _path9, _ellipse8, _ellipse9, _path10, _path11, _ellipse10, _text5, _path12, _path13, _path14, _ellipse11, _path15, _ellipse12, _path16, _ellipse13, _path17, _ellipse14, _path18, _path19, _ellipse15, _ellipse16, _path20, _path21, _ellipse17, _ellipse18, _path22, _ellipse19, _path23, _ellipse20, _rect4, _text6, _path24, _ellipse21, _rect5, _text7, _rect6, _text8, _rect7, _text9, _rect8, _text10, _rect9, _text11, _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGitBranching(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "861px",
    height: "482px",
    viewBox: "-0.5 -0.5 861 482",
    content: "<mxfile host=\"Electron\" modified=\"2022-03-17T13:22:41.611Z\" agent=\"5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/16.5.1 Chrome/96.0.4664.110 Electron/16.0.7 Safari/537.36\" etag=\"BRlLE004naARkme4TqTF\" version=\"16.5.1\" type=\"device\"><diagram id=\"u4Q9mtqc-7ff_6t4GGxs\" name=\"Page-1\">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</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 860,
    height: 480,
    fill: "rgb(255, 255, 255)",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 70,
    width: 710,
    height: 60,
    fill: "rgb(255, 255, 255)",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 120.05 50 C 108.25 50 100 40.39 100 30.15 C 100 17.92 109.85 10 120.2 10 C 130.16 10 140 18.18 140 29.99 C 140 40.58 131.58 50 120.05 50 Z",
    fill: "#0d2636",
    stroke: "none",
    pointerEvents: "all"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 115.72 45.62 C 115.72 46.49 115.07 46.84 114.09 46.51 C 108.17 44.43 102.48 38.03 102.48 30.03 C 102.48 19.21 111.73 12.38 119.75 12.38 C 130.17 12.38 137.57 20.92 137.57 29.92 C 137.57 37.36 132.79 44.2 125.62 46.6 C 124.81 46.81 124.31 46.38 124.31 45.67 L 124.31 40.46 C 124.31 39.45 123.9 38.38 123.14 37.63 C 126.05 37.3 127.82 36.57 129.17 35.18 C 130.5 33.86 131.09 31.93 131.2 29.54 C 131.28 27.64 130.77 25.79 129.4 24.37 C 129.87 23.21 129.96 21.66 129.23 19.76 C 127.79 19.64 126.15 20.51 124.47 21.55 C 121.52 20.78 118.56 20.68 115.61 21.59 C 114.29 20.73 113.09 19.76 110.8 19.76 C 110.2 21.44 110.1 22.98 110.62 24.35 C 108.98 26.16 108.8 27.94 108.83 29.72 C 109.01 33.14 110.26 34.88 111.65 35.91 C 112.81 36.77 114.43 37.3 116.9 37.67 C 116.24 38.32 115.87 39.11 115.8 40.02 C 114.35 40.69 112.27 41.02 110.85 39 C 110.21 37.99 109.35 36.85 107.7 36.85 C 107.43 36.84 107.17 36.95 107.13 37.06 C 107.09 37.19 107.24 37.46 107.42 37.57 C 108.87 38.48 109.1 39 109.69 40.25 C 110.23 41.71 111.18 42.28 112.2 42.67 C 113.25 43.04 114.94 42.94 115.72 42.67 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 15,
    width: 160,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 30,
      marginLeft: 220
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Private Tutor Plus", _br || (_br = /*#__PURE__*/React.createElement("br", null)), "Front-end / Back-end repo")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 34,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Private Tutor Plus...")))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 334,
    cy: 30,
    rx: 10,
    ry: 10,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 460 100 Q 460 100 580 100",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 450 110 Q 450 150 510 150",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 450,
    cy: 100,
    rx: 10,
    ry: 10,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 18,
      height: 1,
      paddingTop: 100,
      marginLeft: 441
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "0.2")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 104,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "0.2")))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 600 100 Q 600 100 750 100",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 590,
    cy: 100,
    rx: 10,
    ry: 10,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 18,
      height: 1,
      paddingTop: 100,
      marginLeft: 581
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "0.3")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 590,
    y: 104,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "0.3")))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 760,
    cy: 100,
    rx: 10,
    ry: 10,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 18,
      height: 1,
      paddingTop: 100,
      marginLeft: 751
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "0.4")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 760,
    y: 104,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "0.4")))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 390,
    cy: 30,
    rx: 10,
    ry: 10,
    fill: "#d5e8d4",
    stroke: "#82b366",
    pointerEvents: "all"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 440,
    cy: 30,
    rx: 10,
    ry: 10,
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 200 200 Q 200 200 400 200",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190,
    cy: 200,
    rx: 10,
    ry: 10,
    fill: "#d5e8d4",
    stroke: "#82b366",
    pointerEvents: "all"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 190 320 Q 190 395 220 395",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 190 320 Q 190 440 220 440",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 200 310 Q 200 310 370 310",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 190,
    cy: 310,
    rx: 10,
    ry: 10,
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 490,
    cy: 30,
    rx: 10,
    ry: 10,
    fill: "#e1d5e7",
    stroke: "#9673a6",
    pointerEvents: "all"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 130 110 Q 130 200 180 200",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 140 100 Q 140 100 440 100",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 130,
    cy: 100,
    rx: 10,
    ry: 10,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 18,
      height: 1,
      paddingTop: 100,
      marginLeft: 121
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "0.1")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 104,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "0.1")))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 130 110 Q 130 310 180 310",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 390 310 Q 410 310 410 210",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 390 310 Q 390 310 520 310",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 380,
    cy: 310,
    rx: 10,
    ry: 10,
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 240 395 Q 260 395 255 395 Q 250 395 270 395",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 230,
    cy: 395,
    rx: 10,
    ry: 10,
    fill: "#e1d5e7",
    stroke: "#9673a6",
    pointerEvents: "all"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 290 395 Q 310 395 307 395 Q 304 395 324 395",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280,
    cy: 395,
    rx: 10,
    ry: 10,
    fill: "#e1d5e7",
    stroke: "#9673a6",
    pointerEvents: "all"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 344 395 Q 380 395 380 320",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 334,
    cy: 395,
    rx: 10,
    ry: 10,
    fill: "#e1d5e7",
    stroke: "#9673a6",
    pointerEvents: "all"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 420 200 Q 450 200 450 110",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 420 200 Q 420 200 640 200",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 410,
    cy: 200,
    rx: 10,
    ry: 10,
    fill: "#d5e8d4",
    stroke: "#82b366",
    pointerEvents: "all"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 230,
    cy: 440,
    rx: 10,
    ry: 10,
    fill: "#e1d5e7",
    stroke: "#9673a6",
    pointerEvents: "all"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 380 440 Q 380 440 240 440",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 400 440 Q 530 440 530 320",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 390,
    cy: 440,
    rx: 10,
    ry: 10,
    fill: "#e1d5e7",
    stroke: "#9673a6",
    pointerEvents: "all"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 560,
    cy: 30,
    rx: 10,
    ry: 10,
    fill: "#fff2cc",
    stroke: "#d6b656",
    pointerEvents: "all"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 530 150 Q 582.88 150 582.93 107.07",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 520,
    cy: 150,
    rx: 10,
    ry: 10,
    fill: "#fff2cc",
    stroke: "#d6b656",
    pointerEvents: "all"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 540 310 Q 650 310 650 210",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 530,
    cy: 310,
    rx: 10,
    ry: 10,
    fill: "#dae8fc",
    stroke: "#6c8ebf",
    pointerEvents: "all"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 70,
    width: 110,
    height: 20,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 80,
      marginLeft: 145
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Protected Branch")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 145,
    y: 84,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Protected Branch")))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 660 200 Q 760 200 760 110",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 650,
    cy: 200,
    rx: 10,
    ry: 10,
    fill: "#d5e8d4",
    stroke: "#82b366",
    pointerEvents: "all"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 20,
    width: 40,
    height: 20,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 1,
      height: 1,
      paddingTop: 30,
      marginLeft: 402
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "UAT")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 402,
    y: 34,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "UAT")))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 344,
    y: 20,
    width: 40,
    height: 20,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 1,
      height: 1,
      paddingTop: 30,
      marginLeft: 346
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Prod")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 346,
    y: 34,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Prod")))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 20,
    width: 40,
    height: 20,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 1,
      height: 1,
      paddingTop: 30,
      marginLeft: 452
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Dev")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 34,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Dev")))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 500,
    y: 20,
    width: 60,
    height: 20,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 1,
      height: 1,
      paddingTop: 30,
      marginLeft: 502
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Feature")))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 502,
    y: 34,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Feature")))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 570,
    y: 20,
    width: 50,
    height: 20,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 1,
      height: 1,
      paddingTop: 30,
      marginLeft: 572
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Hot Fix")))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 572,
    y: 34,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Hot Fix"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitBranching);
export default __webpack_public_path__ + "static/media/GitBranching.967735aa4e502d0b483b7cf3cb338a3b.svg";
export { ForwardRef as ReactComponent };